import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadCurrentUser } from '../redux/modules/auth';
import { loadLikeTypes } from '../redux/modules/likeTypes';
import App from '../views/app';

const mapStateToProps = state => ({
  currentUserLoading: state.auth.loading,
  currentUserLoaded: state.auth.loaded,
  currentUserLoadingError: state.auth.error,
  currentUser: state.auth.user,
  likeTypesLoaded: state.likeTypes.loaded,
  likeTypes: state.likeTypes.likeTypes
});

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ loadCurrentUser, loadLikeTypes }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/containers/app.js